<template>
  <div class="wechat-header">
    <div class="grid-content bg-purple">
      {{title}}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Header",
  props: {
    title: "",
    more: ""
  },
  data() {
    return {};
  },
  computed: mapState({}),
  methods: {
    ...mapActions([])
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.wechat-header{
  height: 40px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  background: #0a0e22;
}
</style>
